import React from "react";
import { formatDateWithoutTime } from "../../utils/formateDate";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { months } from "../../utils/months";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useNavigate, useParams } from "react-router";


const LeaderShip = ({ earnedIncentive }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
   const handleExpand = () => {
   navigate('/incentives');
  };
  return (
    <div className="col-md-6">
      <div className="joinings_viewBox">
        <div className="joinings_viewBox_head">
          <h5>{t("FOreverDrive")}</h5>
          <p style={{ textAlign: "right" }}>  <a className="btn btn-tree-act" onClick={handleExpand}>
                <i className="fa fa-expand"></i>
              </a></p>
        </div>
        <div className="row">
          <div className="forver_content">
            <span className="key">{t("QualificationLevel")}</span>
            <span className="value">{earnedIncentive?.earnedIncentiveLevel ? ` Level ${earnedIncentive?.earnedIncentiveLevel}` : "-" }</span>
          </div>
          <div className="forver_content">
            <span className="key">{t("4kcActive")}</span>
            <span className="value">{earnedIncentive?.currentmonth?.activeStatus ? "YES" : "NO"}</span>
          </div>
          <div className="forver_content">
            <span className="key">{t("ativeManagers")}</span>
            <span className="value">{earnedIncentive?.currentmonth?.downlineLeaderCount ? earnedIncentive?.currentmonth?.downlineLeaderCount : "0"}</span>
          </div>
            <div className="forver_content">
            <span className="key">{t("totalPv")}</span>
            <span className="value">{earnedIncentive?.currentmonth?.totalRmpv}</span>
          </div>
        </div>
        <div className="row forever_table" style={{padding:"15px"}}>
          <table className="table"  >


            <tr>
              <td>Months</td>
              {earnedIncentive?.points.map((pointObj) => (
                <td>{months[pointObj.month]}</td>
              ))}
            </tr>
            <tr>
              <td>{t("Level 1")}</td>
              <td>
                <div>{earnedIncentive?.level[0]?.monthOne}</div>
                <div>
                  <ProgressBar
                    now={earnedIncentive?.points[0]?.totalPV}
                    variant="success"
                    max={earnedIncentive?.level[0]?.monthOne}
                  />
                </div>
                {/* <div>
                  <ProgressBar now={earnedIncentive?.points[2]?.totalPV}  variant="success"  max={earnedIncentive?.level[0]?.monthOne}/>
                </div> */}
                </td>
            
              <td>
                <div>
                {earnedIncentive?.level[0]?.monthTwo}
                </div><div>
                  <ProgressBar now={earnedIncentive?.points[1]?.totalPV} variant="success"  max={earnedIncentive?.level[0]?.monthTwo}/>
                  </div></td>
          

                  <td>
                <div>
                {earnedIncentive?.level[0]?.monthThreeLess}
                </div>
                <div><ProgressBar now={earnedIncentive?.points[2]?.totalPV} variant="success" max={earnedIncentive?.level[0]?.monthThreeLess}/></div>
              </td>
            </tr>
            <tr>
              <td>{t("Level 2")}</td>
               <td><div>{earnedIncentive?.level[1]?.monthOne}</div><div><ProgressBar now={earnedIncentive?.points[0]?.totalPV}  variant="success"  max={earnedIncentive?.level[1]?.monthOne}/></div></td>
             
              <td><div>{earnedIncentive?.level[1]?.monthTwo}</div><div><ProgressBar now={earnedIncentive?.points[1]?.totalPV}  variant="success"  max={earnedIncentive?.level[1]?.monthTwo}/></div></td>
             

               <td>
                <div>
                {earnedIncentive?.level[1]?.monthThreeLess}
                </div>
                <div>
                   <ProgressBar now={earnedIncentive?.points[2]?.totalPV}  variant="success"  max={earnedIncentive?.level[1]?.monthThreeLess}/>
                </div>
                </td>
            </tr>
            <tr>
              <td>{t("Level 3")}</td>
              <td>
                <div>{earnedIncentive?.level[2]?.monthOne}</div>
                <div>
                  <ProgressBar
                    now={earnedIncentive?.points[0]?.totalPV}
                    variant="success"
                    max={earnedIncentive?.level[2]?.monthOne}
                  />
                </div>
              </td>

             
              <td><div>{earnedIncentive?.level[2]?.monthTwo}</div><div><ProgressBar now={earnedIncentive?.points[1]?.totalPV}  variant="success"  max={earnedIncentive?.level[2]?.monthTwo}/></div></td>

               <td><div>{earnedIncentive?.level[2]?.monthThreeLess}</div><div><ProgressBar now={earnedIncentive?.points[2]?.totalPV}  variant="success"  max={earnedIncentive?.level[2]?.monthThreeLess}/></div></td>
            </tr>
            <tr>
              <td>{t("Total KC")}</td>
              <td>{ earnedIncentive?.points[0]?.totalPV}</td>
              <td>{earnedIncentive?.points[1]?.totalPV}</td>
              <td>{earnedIncentive?.points[2]?.totalPV}</td>
            </tr>
                <tr>
              <td>{t("ActiveManagers")}</td>
                 <td>{ earnedIncentive?.points[0]?.downlineLeaderCount}</td>
              <td>{earnedIncentive?.points[1]?.downlineLeaderCount}</td>
              <td>{earnedIncentive?.points[2]?.downlineLeaderCount}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LeaderShip;
